import { InputTextArea } from '@components-common/forms';
import { TTFormInputPropsGeneric } from './input.types';

export const InputDescription = ({id = "description", ...rest}: TTFormInputPropsGeneric) => (<InputTextArea id={id} {...rest} />)
